import { ROLE } from "@/router/role.constant";

export const PATH = {
	home: {
		path: "/",
		allowedRole: [...Object.values(ROLE)],
	},
	record: {
		path: "/record",
		allowedRole: [],
	},
	login: {
		path: "/login",
		allowedRole: [...Object.values(ROLE)],
	},
	allocation: {
		path: "/allocation",
		allowedRole: [ROLE.admin],
	},
	allocationDetail: {
		path: "/allocationDetail",
		allowedRole: [ROLE.admin],
	},
	upload: {
		path: "/upload",
		allowedRole: [ROLE.admin],
	},
	export: {
		path: "/export",
		allowedRole: [ROLE.admin],
	},
	settings: {
		path: "/settings",
		allowedRole: [ROLE.admin],
	},
	result: {
		path: "/result",
		allowedRole: [ROLE.admin],
	},
	// do not auth
	tripSummary: {
		path: "/latest-daily-summary",
	},
	tripDetail: {
		path: "/trip-detail/:orderSubId?",
	},
	busDetail: {
		path: "/bus-detail/:vehiclePlate",
	},
};
